/*
 * File: FeedAction.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:39 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';


/**
 * Styles
 */

export const ActionButton = styled.button`
	display: flex;
	gap: 5px;
	align-items: center;
	border: none;
	background-color: transparent;
	cursor: pointer;
	padding: 0px 10px;
    height: 32px;
	border-radius: 20px;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
	}
	${({ $isOpen }) => $isOpen && css`
		background-color: ${({ theme }) => theme.neutralButton};
	`}
	* {
		color: ${({ theme }) => theme.secondaryText};
	}
	svg {
		font-size: 0.84rem;

		${({ $isOpen }) => $isOpen && css`
			transform: rotate(180deg);
		`}
	}
`;
